import type { LocationCoordinates } from '@/modules/dashboard/dashboardTypes';
import service, { type HttpResponseSuccess } from './service';

const apiService = service(`${process.env.REACT_BACKEND_HOST}`);

export const getLists = (): any => apiService.get('/api/list/get');

export const addList = (
	name: string,
	businessIds: string[],
	selectedLocation: string
): any =>
	apiService.post('/api/list/add', {
		name,
		businessIds,
		selectedLocation
	});

export const editList = (listId: string, name: string): any =>
	apiService.put('/api/list/edit', {
		listId,
		name
	});

export const addBusinessesToList = (
	businessIds: string[],
	listId: string,
	selectedLocation?: string
): any =>
	apiService.put('/api/list/addBusiness', {
		businessIds,
		listId,
		selectedLocation
	});

type RemoveBusinessFromListParams = {
	businessId: string;
	listId: string;
};

type RemoveBusinessFromListResponse = {
	location: LocationCoordinates;
	createdEmpty: boolean;
	userId: string;
	name: string;
	businessIds: Array<string>;
	smartList: boolean;
	deleted: boolean;
	createdAt: string;
	updatedAt: string;
	id: string;
};

export const removeBusinessFromList = ({
	businessId,
	listId
}: RemoveBusinessFromListParams): Promise<
	HttpResponseSuccess<RemoveBusinessFromListResponse>
> =>
	apiService.put('/api/list/removeBusiness', {
		businessId,
		listId
	});

export const removeList = (
	listId: string
): Promise<HttpResponseSuccess<unknown>> =>
	apiService.delete('/api/list/remove', { params: { listId } });

export const removeListsBatch = (
	listIds: Array<string>
): Promise<HttpResponseSuccess<unknown>> =>
	apiService.post('/api/list/removeBatch', { listIds });
